import React, {useEffect, useState} from "react"
import { useTranslation } from 'react-i18next';
import {useNavigate} from "react-router-dom";
import AppButton from "app/components/shared/AppButton/AppButton.tsx"
import AddKnowledgeComponent from "./AddKnowledgeComponent/AddKnowledgeComponent.jsx"
import {ButtonTypeEnum, ButtonSizeEnum, ButtonColorEnum} from "app/components/shared/enums/global-enums.tsx"

import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import CancelIcon from '@mui/icons-material/Cancel';

import cssVars from 'app/helpers/_variables.module.scss';
import Typography from '@mui/material/Typography';
import Modal from '@mui/material/Modal';
import useStore from 'app/store/store';
import "./KnowledgeComponents.scss"


const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: 400,
  bgcolor: 'background.paper',
  border: '2px solid #000',
  boxShadow: 24,
  p: 4,
};


export default function KnowledgeComponents({course}){

  const {t} = useTranslation();
  const navigate = useNavigate();
  
  const [openAddKC, setOpenAddKC] = useState(false);
  const [selectedElm, setSelectedElm] = useState(null);
  const [openConfirmation, setOpenConfirmation] = React.useState(false);


  const storeActions = useStore((state) => state.actions);
  
  function saveComponents() {
    // console.log(course.knowledge_comp_step);
    let values = {...course};
    values.knowledge_comp_step = false;
    storeActions.updateOrCreateCourse({course: values}, false, window.location.reload());
    // 
  }

  function toRemove(elm){
    setSelectedElm(elm);
    setOpenConfirmation(true);
  }


  useEffect(() => {
    storeActions.setNavigate(navigate);
  }, [storeActions, navigate]);


  return (
    <Box className="w-100">
      <Box className="center-text " >
        <div className="v-space-1"></div>
        <div className="kc-title">{t("knowledge COMPONENTS")}</div>
        <div className="kc-subtitle">{t("Confirm the components of knowledge relevant for this course")}</div>
        <div className="gray-color">{t("In this course students will learn")}</div>
      </Box>

      <div className="v-space-1"></div>

      <Grid container className="kc-container">
      {
        course.knowledge_components.map((elm, key)=>{
         return(
          <Grid container item xs={4} key={key} className="fourth-color kc-child" >
            <Grid item xs={1} className="ai-t">
              <CancelIcon onClick={()=>toRemove(elm)} className={"fourth-color pointer"} />
            </Grid>

            <Grid item xs>
              {elm.title}
            </Grid>
          </Grid>
         ) 
        })
      }
      </Grid>


      {
        !openAddKC &&
        <Box className="center-text">
          <div className="v-space-3"></div>
          <AppButton 
           onClickFunc={()=>setOpenAddKC(true)}
           buttonType={ButtonTypeEnum.TEXT_OUTLINE}
           buttonColor={ButtonColorEnum.FOURTH}
           buttonLabel={t("+ Add Knowledge")}
           buttonSize={ButtonSizeEnum.SMALL}
           actionType="button"
           />
        </Box>
      }
      

      {
        openAddKC &&
        <Box >
          <Box  className="center-el" style={{maxWidth: '400px'}}> 
            <AddKnowledgeComponent setOpenAddKC={setOpenAddKC}/>
          </Box>
        </Box>
      }



      <div className="v-space-3"></div>
      
      <Box className="center-text">
        <AppButton 
          onClickFunc={saveComponents}
          sx={{backgroundColor: cssVars['fourth-color']}}
          buttonType={ButtonTypeEnum.SECONDARY}
          buttonLabel={t("Done!")}
          buttonSize={ButtonSizeEnum.SMALL}
          actionType="button"
         />
      </Box>
      <div className="v-space-5"></div>
      <ModelConfirmation selectedElm={selectedElm} course={course} openConfirmation={openConfirmation} setOpenConfirmation={setOpenConfirmation} />
    </Box>
  );

}

function ModelConfirmation({selectedElm, course, openConfirmation, setOpenConfirmation}) {
  const {t} = useTranslation();

  const storeActions = useStore((state) => state.actions);

  return (
    <Modal
      open={openConfirmation}
      onClose={()=>setOpenConfirmation(false)}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <Box sx={style}>
        <Typography id="modal-modal-title" variant="h6" component="h2">
          {t("Delete confirmation")}
        </Typography>
        <Typography id="modal-modal-description" sx={{ mt: 2 }}>
          {t("Do you want to remove this item?")}
        </Typography>
        <div className="v-space-3"></div>
         <AppButton 
          onClickFunc={()=>{
            storeActions.deleteKnowledgeComponent({knowledge_component: selectedElm, courseId: course.id});
            setOpenConfirmation(false);
          }}
          sx={{backgroundColor: cssVars['fourth-color']}}
          buttonType={ButtonTypeEnum.SECONDARY}
          buttonLabel={t("Ok!")}
          buttonSize={ButtonSizeEnum.MEDIUM}
          actionType="button"
         />
      </Box>
    </Modal>
    )
}